import analytics from '..';

async function trackFormCompletedEvent(formId, startTime) {
  const formSubmittedPayload = {
    form_id:        formId,
    start_datetime: startTime, // as String
    end_datetime:   new Date().toISOString(),
  };
  await analytics.track('formCompleted', formSubmittedPayload);
}
export default trackFormCompletedEvent;
